/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PatchedWaterQualityCustomizedResultAreaGeometry } from "./PatchedWaterQualityCustomizedResultAreaGeometry";
import {
  PatchedWaterQualityCustomizedResultAreaGeometryFromJSON,
  PatchedWaterQualityCustomizedResultAreaGeometryFromJSONTyped,
  PatchedWaterQualityCustomizedResultAreaGeometryToJSON,
  PatchedWaterQualityCustomizedResultAreaGeometryToJSONTyped,
} from "./PatchedWaterQualityCustomizedResultAreaGeometry";
import type { SubsetsEnum } from "./SubsetsEnum";
import {
  SubsetsEnumFromJSON,
  SubsetsEnumFromJSONTyped,
  SubsetsEnumToJSON,
  SubsetsEnumToJSONTyped,
} from "./SubsetsEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedWaterQualityCustomizedResultArea
 */
export interface PatchedWaterQualityCustomizedResultArea {
  /**
   *
   */
  readonly url?: string;
  /**
   * Name of the customized results area.
   */
  name?: string;
  /**
   * Subsets of the customized results area. Valid subsets are: 1D, 2D, 1D2D, GW.
   */
  subsets?: Array<SubsetsEnum>;
  /**
   *
   */
  geometry?: PatchedWaterQualityCustomizedResultAreaGeometry;
}

/**
 * Check if a given object implements the PatchedWaterQualityCustomizedResultArea interface.
 */
export function instanceOfPatchedWaterQualityCustomizedResultArea(
  value: object
): value is PatchedWaterQualityCustomizedResultArea {
  return true;
}

export function PatchedWaterQualityCustomizedResultAreaFromJSON(
  json: any
): PatchedWaterQualityCustomizedResultArea {
  return PatchedWaterQualityCustomizedResultAreaFromJSONTyped(json, false);
}

export function PatchedWaterQualityCustomizedResultAreaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedWaterQualityCustomizedResultArea {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    name: json["name"] == null ? undefined : json["name"],
    subsets:
      json["subsets"] == null
        ? undefined
        : (json["subsets"] as Array<any>).map(SubsetsEnumFromJSON),
    geometry:
      json["geometry"] == null
        ? undefined
        : PatchedWaterQualityCustomizedResultAreaGeometryFromJSON(json["geometry"]),
  };
}

export function PatchedWaterQualityCustomizedResultAreaToJSON(
  json: any
): PatchedWaterQualityCustomizedResultArea {
  return PatchedWaterQualityCustomizedResultAreaToJSONTyped(json, false);
}

export function PatchedWaterQualityCustomizedResultAreaToJSONTyped(
  value?: Omit<PatchedWaterQualityCustomizedResultArea, "url"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    subsets:
      value["subsets"] == null
        ? undefined
        : (value["subsets"] as Array<any>).map(SubsetsEnumToJSON),
    geometry: PatchedWaterQualityCustomizedResultAreaGeometryToJSON(value["geometry"]),
  };
}
